import TypingEffect from './TypingEffect'

export default TypingEffect